import React from 'react';

import { useLanguage } from '../LanguageContext';

export default function NameStep({
  formData,
  setFormData,
  allGuests = [],
  mainGuestName,
  onNext,
  onCancel,
}) {
  const { t } = useLanguage();
  const presentGuests = Array.isArray(allGuests)
    ? allGuests.filter(Boolean)
    : [];

  return (
    <div className="space-y-6 text-center">
      <h2 className="text-4xl text-content-h1 tracking-tight">
        {t('rsvp_form.confirm_title')}
      </h2>
      {presentGuests.length > 0 && (
        <div className="rounded-3xl p-2 text-left">
          <p className="text-xl uppercase text-content-h2">
            {t('rsvp_form.guests_on_invitation')}
          </p>
          <div className="mt-3 space-y-2">
            {presentGuests.map((name, index) => (
              <div
                key={`${name}-${index}`}
                className="rounded-2xl border border-wedding-divider bg-wedding-offwhite px-4 py-3 text-xl text-content-c2"
              >
                {name}
              </div>
            ))}
          </div>
        </div>
      )}
      <p className="text-xl text-content-c1">{t('rsvp_form.confirm_msg')}</p>
    </div>
  );
}
